import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import HSNType from "../types/HSNType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const HSNAction = {
  getList:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getData: any = await axios.get(BASE_URL + "hsn-list", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        dispatch({
          type: HSNType.GET_HSN_LIST,
          payload: getData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default HSNAction;
